export default __webpack_public_path__ + "static/media/DL.156d5261.svg";